import { graphql } from "../../../../../graphql";

export const PageProductIdsSub = graphql(`
    subscription PageProductIdsSub {
      page_products {
        product_id
      }
    }
  `);
